import { Expression } from '../../../prix/types/expression'

export interface Answer {
  id?: string
  questionId: number
  answerId: number | null
  string: string | null
  boolean: boolean | null
  numeric: number | null
  array: number[] | null
  date: string | null
}

export interface FetchedQuestion {
  id: number
  title: string
  observation: string
  type: QuestionTypes
  required: boolean
  questionnaireId: number
  questionOptions: {
    id: number
    label: string
  }[]
}

export interface QuestionWithQuestionnaireInfo extends FetchedQuestion {
  questionnaireId: number
  questionnaireTitle: string
  questionnaireObservation: string
  questionnaireLgpdDisclaimer: string
  questionnaireTargetType: string
  questionnaireTargetPublic: Expression | null
  questionnaireDelimitationType: string
  questionnaireDelimitationId: number
  questionnaireDelimitationCustom: string
  questionnaireStartDate: Date
  questionnaireEndDate: Date
  updatedAt: Date
}

export type QuestionnaireType = {
  id: number
  title: string
  observation: string
  lgpdDisclaimer: string
  targetType: string
  targetPublic: string
  delimitationType: string
  delimitationId: number | null
  delimitationCustom: string | null
  startDate: Date
  endDate: Date | null
  createdAt: Date
  updatedAt: Date | null
  deletedAt: Date | null
  questions: Question[]
}

export type QuestionTypes =
  | 'optionButton'
  | 'freeText'
  | 'checkBox'
  | 'numeric'
  | 'date'
  | 'boolean'
  | 'select'

export const inputTypesAux = {
  optionButton: 'radio',
  freeText: 'text',
  checkBox: 'checkbox',
  numeric: 'number',
  date: 'date',
  boolean: 'radio',
  select: 'select',
}

export type QuestionOption = {
  id: number
  label: string
  deletedAt?: string | null
}

export interface NewQuestion {
  title: string
  observation: string
  type: QuestionTypes
  required: boolean
  ordinalPosition: number
  deletedAt: string | null
  questionOptions: QuestionOption[]
  questionnaireId: number
  childQuestions: NewQuestion[] | null
}

export interface TargetProps {
  targetPublic: any
  targetType?: string
}

export interface DelimitationProps {
  delimitationType: string | null
  delimitationId: number | null
  delimitationCustom: string | null
}

export interface QuestionnaireDataType extends TargetProps, DelimitationProps {
  id: number | null
  title: string
  observation: string
  startDate: string
  endDate: string | null
  lgpdDisclaimer: string
  deletedAt: string | null
}

export interface Question extends NewQuestion {
  id: number
  parentQuestionId: number | null
}

export interface AnswerSheet {
  professionalId: number
  familyId: number
  citizenId: number
}

export interface NewFieldProps {
  title: string
  observation?: string | null | undefined
  type: string
  required: boolean
  ordinalPosition: number
  deletedAt: string | null
  questionOptions: QuestionOption[]
  childQuestions: NewFieldProps[] | null
}

export interface CitizenInfoProps {
  name: string
  socialName: string | null
  cns: string | null
  cpf: string | null
  age: number | null
  questionnaires: QuestionnaireType[]
  hash: string
  answers: Answer[]
}

export interface TargetPublicProps {
  kind: string
  label: string
  left: {
    kind: string
    type: string
    property: string
  }
  operator: string
  right: {
    kind: string
    type: string
    value: string
    literalType: string
  }
  type: string
  value: string
}

export interface QuestionnaireListItemProps {
  id: number
  observation: string | null
  startDate: string
  endDate: string | null
  targetPublic: TargetPublicProps
  targetType: string
  title: string
}

export interface ActionListProps {
  id: number
  observation?: string | null
  startDate: string
  targetPublic: string
  targetType: string
  title: string
}
